import React, { FC } from 'react';
import Group from './Group';
import { IMRBeaconSVGProps } from './icons.types';

const CircleGroup: FC<IMRBeaconSVGProps> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
    >
      <circle id="Ellipse 36" cx="24" cy="24.5" r="15.5" stroke="black" />
      <foreignObject x="8.5" y="9" width="31" height="31">
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '100%',
          }}
        >
          <Group />
        </div>
      </foreignObject>
    </svg>
  );
};

export default CircleGroup;
